module.exports = __webpack_public_path__ + "img/ilst_letter2020.e43ef85d.png";